<template>
  <el-dialog
    :visible.sync="visible"
    title="发票详情"
    width="80%"
    @close="handleClose"
    v-loading="loading"
  >
    <div class="invoice-detail">
      <h3>发票基本信息</h3>
      <el-descriptions :column="3" border>
        <el-descriptions-item label="发票抬头">{{ invoiceData.title }}</el-descriptions-item>
        <el-descriptions-item label="纳税人识别号">{{ invoiceData.tax_number }}</el-descriptions-item>
        <el-descriptions-item label="发票号码">{{ invoiceData.invoice_no }}</el-descriptions-item>
        <el-descriptions-item label="发票代码">{{ invoiceData.invoice_code }}</el-descriptions-item>
        <el-descriptions-item label="开票金额">{{ invoiceData.amount }}</el-descriptions-item>
        <el-descriptions-item label="税额">{{ invoiceData.tax_amount }}</el-descriptions-item>
        <el-descriptions-item label="发票地址">
          <a :href="invoiceData.url" target="_blank">查看</a>
        </el-descriptions-item>
        <el-descriptions-item label="开票时间">{{ invoiceData.date }}</el-descriptions-item>
        <el-descriptions-item label="是否红冲">{{ invoiceData.is_canceled }}</el-descriptions-item>
        <el-descriptions-item label="红冲时间" v-if="invoiceData.canceled_at">{{ invoiceData.canceled_at }}</el-descriptions-item>
        <el-descriptions-item label="红冲原因" v-if="invoiceData.red_reason">{{ invoiceData.red_reason }}</el-descriptions-item>
        <el-descriptions-item label="备注" v-if="invoiceData.remark">{{ invoiceData.remark }}</el-descriptions-item>
      </el-descriptions>

      <h3>关联费项信息</h3>
      <el-table :data="financeList" border style="margin-top: 10px">
        <el-table-column label="合同名称" prop="contract_name" width="200" />
        <el-table-column label="费项名称" prop="finance_name" width="150" />
        <el-table-column label="费项月份" prop="finance_month" width="120" />
        <el-table-column label="费项金额" prop="finance_amount" width="120" />
        <el-table-column label="开票金额" prop="invoice_money" width="120" />
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.status === 1">正常</span>
            <span v-else-if="scope.row.status === 0" style="color: red">作废</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ContractInvoiceDetail',
  props: {
    invoiceId: {
      type: [String, Number],
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      invoiceData: {},
      financeList: []
    };
  },
  watch: {
    invoiceId: {
      immediate: true,
      handler(newId) {
        if (newId) {
          this.fetchInvoiceData(newId);
        }
      }
    }
  },
  methods: {
    async fetchInvoiceData(id) {
      this.loading = true;

      try {
        this.$myhttp
          .post(
            "contract/Invoice/detail",
            { id },
            {
              "Content-Type": "application/json",
            }
          )
          .then((backdata) => {
            if (backdata.data.code == 200) {
              this.invoiceData = backdata.data.data.invoice || {};
              this.financeList = backdata.data.data.finance_list || [];
            } else {
              this.$message.error(backdata.data.msg);
            }
          })
          .catch((err) => {
            this.$message.error(err);
          })
          .finally(() => {
            this.loading = false;
          });
      } catch (error) {
        this.loading = false;
      }
    },
    handleClose() {
      this.$emit('close', false);
    }
  }
}
</script>

<style scoped>
.invoice-detail {
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
}

h3 {
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: 18px;
  color: #333;
}

a {
  color: #007bff;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/InvoiceDetail.vue